<template>
  <div
    class="card mt-3 card-complete"
    v-bind:class="{ 'card-active': currentTab === number }"
  >
    <div
      :id="number"
      class="card-header pt-2 pb-2 cursor-pointer my-auto"
      @click="toogleCard($event, number)"
    >
      <font-awesome-icon
        v-if="currentTab === number"
        class="mr-2 fa-sm"
        icon="chevron-down"
      />
      <font-awesome-icon
        v-if="currentTab !== number"
        class="mr-2 fa-sm"
        icon="chevron-right"
      />
      <span class="h6">{{ t(title) }}</span>
      <span
        class="float-right btn-continue"
        v-if="currentTab === number"
        v-translate
        >Next</span
      >
    </div>
    <transition name="fade">
      <div
        :id="'step-' + number"
        class="card-body"
        v-show="currentTab === number"
      >
        <slot></slot>
        <input type="hidden" value="loaded" :id="'loaded-' + number" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['title', 'currentTab', 'completed'],
  data: function () {
    return {
      tabState: {},
      number: Math.random() * 10000,
    }
  },
  created() {
    this.tabState[this.number] = this.number

    let urlTxt = document.getElementsByClassName('isUrl')
    for (let i = 0; i < urlTxt.length; i++) {
      urlTxt[i].addEventListener('keyup', function (e) {
        e.value = e.value.replace('/', '')
      })
    }

    if (this.completed) {
      this.tabState[this.number] = 'completed'
    }
  },
  methods: {
    toogleCard(e, n) {
      let state = {
        original: this.number,
        to: n,
      }

      if (e.target.classList.contains('btn-continue')) {
        // go next
        try {
          let header = document.getElementsByClassName('card-header')
          for (let i = 0; i < header.length; i++) {
            this.currentTab = 0
            if (this.number === Number(header[i].id)) {
              this.currentTab = Number(header[i + 1].id)
              break
            }
          }
        } catch (err) {}
      } else {
        if (this.currentTab === n) {
          this.currentTab = 0
        } else {
          this.currentTab = n
        }
      }

      state.to = this.currentTab

      this.$emit('toogle', state)
    },
    validate(number) {
      let completed = true
      let requiredForm = null

      let stepId = document.getElementById('step-' + number)
      let hasElm = document.getElementById('loaded-' + number)

      if (stepId) requiredForm = stepId.getElementsByClassName('required')

      if (!hasElm) return

      if (requiredForm) {
        this.tabState[number] = 'completed'

        for (var i = 0; i < requiredForm.length; i++) {
          if (requiredForm[i].value === '') {
            requiredForm[i].classList.add('is-invalid')
            this.tabState[number] = 'incomplete'
            completed = false
          } else {
            this.tabState[number] = 'completed'
            completed = true
            requiredForm[i].classList.remove('is-invalid')
          }

          if (requiredForm[i].classList.contains('isUrl')) {
            if (!this.isURL(requiredForm[i].value)) {
              requiredForm[i].classList.add('is-invalid')
              this.tabState[number] = 'incomplete'
              completed = false
            } else {
              this.tabState[number] = 'completed'
              completed = true
              requiredForm[i].classList.remove('is-invalid')
            }
          }
        }
      } else {
        this.tabState[number] = 'completed'
      }

      return completed
    },
    isURL(str) {
      var pattern = new RegExp('^[a-z0-9.]+[.]{1}[a-z]{2,3}', 'i')
      return pattern.test(str)
    },
  },
}
</script>

<style>
.card-fade {
  opacity: 0.4;
}

.card-fade:hover {
  opacity: 1;
}

.card-complete {
  opacity: 1;
}

.card-active {
  opacity: 1;
}

.card-active .card-header {
  background-color: rgba(var(--main-color),1);
  color: #ffffff;
  vertical-align: center;
}

.hide {
  display: none;
}

.btn-continue {
  background-color: #ff5757;
  color: #ffffff;
  border-radius: 4px;
  padding: 1px 10px;
  font-weight: 500;
  cursor: pointer;
}

.green {
  background-color: #29ad30;
}

.red {
  background-color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Step.vue